module.exports = __webpack_public_path__ + "img/fg-3_3.prt.4da5b314.jpg";